import { compact, flow } from 'lodash/fp'
import { appendBefore, concatWith, createPageCreator } from 'e-submission/domain/data-model/form/utils'
import investmentBaseForm from 'e-submission/domain/data-model/product-form/product-investment/base'
import { insuredHealth, payerHealth } from 'e-submission/domain/data-model/form/pages/health'
import { submit } from 'e-submission/domain/data-model/form/pages/submit'
import { signature } from '../signature'
import submitApplicationSection from './submitSection'

export default (app) => {
  const createPage = createPageCreator(app)
  return flow(
    investmentBaseForm(createPage, false),
    appendBefore(null, 'FATCA', [createPage(insuredHealth(app)), createPage(payerHealth(app))]),
    concatWith([
      createPage(signature(app)),
      createPage(
        submit({
          sections: [submitApplicationSection('submit-application')],
        })
      ),
    ]),
    compact
  )(app)
}
